export default function toLatLng(obj) {
	if (obj) {
		return {
			...obj,
			lat: obj.latitude,
			lng: obj.longitude
		};
	}

	return undefined;
}
